// Pathify
import Vue from 'vue'
import { make } from 'vuex-pathify'
import axios from 'axios'
import router from '@/router'

Vue.use(router)

// Data
const state = {
  options: {},
  search: '',
}

const mutations = {
  ...make.mutations(state),
}

const actions = {
  ...make.actions(state),
  init: async ({ dispatch }) => {
  },
  start (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/payment/start', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        reject(error)
      })
    })
  },
  status (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/payment/status', payload)
        .then(result => {
          resolve(result.data)
        }).catch(error => {
        reject(error)
      })
    })
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
